import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _fetchUsersQuery from "./__generated__/fetchUsersQuery.graphql";
import { fetchQuery, graphql } from 'react-relay';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';
import { ErrorWithStatusCode } from '../../common/utils/errors/error-with-status-code';
export var fetchUsers = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(environment, accountIds, createAnalyticsEvent) {
    var apiStartTime, response, apiLatencyMs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          apiStartTime = performance.now();
          _context.next = 4;
          return fetchQuery(environment, /* eslint-disable @atlassian/relay/unused-fields */_fetchUsersQuery, {
            accountIds: accountIds
          }, {
            networkCacheConfig: {
              force: false
            },
            fetchPolicy: 'store-or-network'
          }).toPromise();
        case 4:
          response = _context.sent;
          if (response !== null && response !== void 0 && response.users) {
            _context.next = 7;
            break;
          }
          throw new ErrorWithStatusCode('[fetch-users service] [fetchUsersQuery]: Property users does not exist.', {
            cause: 'FETCH_USERS_MISSING_USERS_PROPERTY'
          }, 'FETCH_USERS_MISSING_USERS_PROPERTY');
        case 7:
          apiLatencyMs = Math.floor(performance.now() - apiStartTime);
          fireOperationalEvent(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchUsers',
            attributes: {
              usersAPILatency: apiLatencyMs
            }
          });
          return _context.abrupt("return", _toConsumableArray(response.users));
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](0);
          if (!_context.t0.cause) {
            _context.t0.cause = 'FETCH_USERS_UNKNOWN_ERROR';
          }
          throw _context.t0;
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 12]]);
  }));
  return function fetchUsers(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();